var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTumblr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.02.51C5.65.51.5 5.66.5 11.99s5.15 11.5 11.52 11.5 11.48-5.17 11.48-11.5S18.35.51 12.02.51zm3.43 18.1h-2.24c-2.01 0-3.52-1.04-3.52-3.52v-3.97H7.86V8.97c2.01-.52 2.86-2.26 2.95-3.76h2.09v3.41h2.44v2.5H12.9v3.46c0 1.04.52 1.39 1.36 1.39h1.18v2.63z"
  })));
}

export default SvgTumblr;